import { initFilteredSearchServiceDesk, mountServiceDeskListApp } from '~/issues/service_desk';

initFilteredSearchServiceDesk();
mountServiceDeskListApp();
